import React from "react";
import { Button, message, Popconfirm } from "antd";

import { _getOrderStatus, _postSetProductOrderStatusToAwaitPayment } from "../../services";

class SetAwaitPaymentButton extends React.Component {

    constructor(props) {
        super(props);

        if (!props.cartId) {
            throw "SetAwaitPaymentButton.props.cartId is required";
        }

        this.state = {
            loading: true
        };

    }

    componentDidMount() {

        const { cartId } = this.props;

        _getOrderStatus({ cartId })
            .then(res => {

                this.setState({
                    loading: false,
                    orderStatus: res.data.orderStatus,
                });

            });

    }

    render() {

        return (
            <Popconfirm 
                disabled={this.getSetAwaitPaymentIsDisabled()}
                onConfirm={ this.onClickConfirm } 
                okText="Confirm" 
                title="Are you sure? This action is not reversible!">

                <Button 
                    loading={ this.state.loading }
                    disabled={ this.getSetAwaitPaymentIsDisabled() } type="danger">
                    Set to Await Payment
                </Button>
                
            </Popconfirm>
        );

    }

    getProductOrderStatusSelected = () => {

        if( this.state.loading ){
            return [];
        }

        if( this.props.productOrderIds === 0 ){
            return [];
        }

        return this.state.orderStatus.productOrderStatus.filter(
            _productOrderStatus => {

                if( !this.props.productOrderIds.includes( _productOrderStatus.productOrderId ) ){
                    return false;
                }

                return true;

            }
        );

    }

    getProductOrderStatusInvalid = () => {

        let invalid_states  = [ "COMPLETED", "VOIDED", "AWAIT_PAYMENT" ];

        return this.getProductOrderStatusSelected().filter( _pos => {

            if( !invalid_states.includes(_pos.status) ){
                return false;
            }

            return true;

        });

    }

    getSetAwaitPaymentIsDisabled = () => {

        if( this.state.loading ){
            return true;
        }

        if( this.props.productOrderIds.length === 0 ){
            return true;
        }

        return false;

    }

    onClickConfirm = () => {
        
        // Validate that there are no
        let productOrderStatusSelected = this.getProductOrderStatusSelected();
        let productOrderStatusInvalid = this.getProductOrderStatusInvalid();

        message.destroy();

        if( productOrderStatusInvalid.length > 0 ){

            productOrderStatusInvalid.map( _pos => {

                message.error(`Can't set ${_pos.productTitle} to AWAIT_PAYMENT as it is ${_pos.status}`);

            })

            return;
        }

        let orderStatusId = this.state.orderStatus._id;
        let productOrderStatusIds = productOrderStatusSelected.map( _pos => _pos._id);

        this.setState({ loading: true });

        // call api to set productOrderStatus to await payment
        _postSetProductOrderStatusToAwaitPayment( orderStatusId, productOrderStatusIds )
            .then( res => {

                let orderStatus = res.data.orderStatus;
                message.success(`Updated ${productOrderStatusSelected.length} line item(s) to await payment`);
                this.props.onConfirm( orderStatus );

            })
            .catch( e => {

                message.error( e.toString());

            })
            .finally( () => {
                
                this.setState({ loading: false });

            })


    }

}

export default SetAwaitPaymentButton;


// WEBPACK FOOTER //
// ./src/components/orders-v3/set-await-payment-button.js